module.exports = __webpack_public_path__ + "media/images/business-preview-d7f1b738a39581a006a649fe85113e51.jpg";